import Api from "../../axios";

export const deleteTemplate = async (id) => {
  return await Api.delete(`/Game/DeleteDefaultTemplate?id=${id}`);
};
